import React, {useState, useRef,useEffect} from 'react';
import {
    Row,
    Col,
    Input,
    Collapse,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Pagination,
    PaginationItem,
    PaginationLink,
    Tooltip
} from 'reactstrap';
import Multiselect from 'multiselect-react-dropdown';

const ResourceActions = (props) => {
    const {
        selectedPage,
        total_resources,
        itemsPerPage,
        handlePageClick,
        isOpen,
        toggle,
        setSearch,
        setRegion,
        resourceFilter,
        environmentsFilter,
        healthFilter,
        filterByResourceType,
        unfilterByResourceType,
        filterByEnvironment,
        unfilterByEnvironment,
        filterByHealth,
        unfilterByHealth,
        getFilter,
        getNotificationServiceMappingButton,
        deployButton,
        handleDefaultDeploy,
        initiateRescan,
        handleRefresh,
        startDate,
        endDate,
        handleStartDateChange,
        handleEndDateChange,
        toggleDates,
        isDateOpen,
        handlePredefinedDateChange,
        handleDispatch,
        clearServiceFilter,
        initialResourceFilter,
        initialEnvironmentFilter,
        initialHealthFilter,
        initialSearch,
        initialRegion,
        account_filter = null,
        clearAccountFilter = null,
        service_quota_item=null,
    } = props;
    const [tright, settright] = useState(false);
    const totalPages = Math.ceil(total_resources / itemsPerPage);
    const [name, setName] = useState(initialSearch || '');
    const [regionInput, setRegionInput]  = useState('')
    let startPage = Math.max(selectedPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);
    if (endPage === totalPages) {
        startPage = Math.max(totalPages - 2, 1);
    }
    const resourceTypeRef = useRef(null);
    const environmentRef = useRef(null);
    const healthRef = useRef(null);
    useEffect(() => {
        setName(initialSearch || '');
    }, [initialSearch]);

    useEffect(() => {
        if (initialRegion) {
            setRegionInput(initialRegion);
        }
    }, [initialRegion]);

    useEffect(() => {
        const radioValue = getSelectedRadioValue();
        if (radioValue) {
            const radio = document.querySelector(`input[name="dates-radio"][value="${radioValue}"]`);
            if (radio) {
                radio.checked = true;
            }
        }
    }, [startDate, endDate]);

    const getSelectedRadioValue = () => {
        if (!startDate || !endDate) return '';
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const today = new Date();
        const isEndDateToday = endDate.toDateString() === today.toDateString();
            if (diffDays === 1) return 'last1Day';
            if (diffDays === 3) return 'last3Days';
            if (diffDays === 7) return 'last7Days';
            if (diffDays === 30) return 'last30Days';
        return 'option1';
    };

    const handleRadioChange = (event) => {
        if (event && event.target) {
            const value = event.target.value;
            if (value === 'last1Day') {
                handlePredefinedDateChange(1);
            } else if (value === 'last3Days') {
                handlePredefinedDateChange(3);
            } else if (value === 'last7Days') {
                handlePredefinedDateChange(7);
            } else if (value === 'last30Days') {
                handlePredefinedDateChange(30);
            }
        }
    };

    const handleRadioClick = (event) => {
        if (isDateOpen && event.target.value !== 'option1') {
            toggleDates();
        }
        if (event.target.value === 'option1') {
            toggleDates();
        } else {
            handleRadioChange(event);
        }
    };

    const handleClearFilters = (e) => {
        e.preventDefault();
        filterByResourceType([])
        setSearch({ target: { value: "" } })
        setRegion({ target: { value: "" } })
        setName('');
        setRegionInput('');

        handleStartDateChange({ target: { value: "" } });
        handleEndDateChange({ target: { value: "" } });
        document.querySelectorAll('input[name="dates-radio"]').forEach(input => input.checked = false);
        resourceTypeRef.current.resetSelectedValues();
        environmentRef.current.resetSelectedValues();
        healthRef.current.resetSelectedValues();
        clearServiceFilter();
        if (clearAccountFilter) {
            clearAccountFilter();
        }
        handlePageClick(1)
        handleDispatch();
        toggle()
    };

    return (
        <>
            <Row className="mb-3">
                <Col md="2">
                    <div className="position-relative hstack gap-3">
                        <a href="#" onClick={toggle} className="btn btn-secondary w-100">
                            <i className="bx bx-filter-alt align-middle"></i> Search & Filter
                        </a>
                    </div>
                </Col>
                <Col md="7">
                </Col>
                <Col md="1">
                    <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                            <UncontrolledDropdown className="dropdown d-inline-block me-1">
                                <DropdownToggle type="menu" className="btn btn-success" id="dropdownMenuButton1">
                                    Bulk Actions
                                    <i className="mdi mdi-dots-vertical"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                    <li>{getNotificationServiceMappingButton()}</li>
                                    <li>
                                        {deployButton ? (
                                            <DropdownItem href="#" onClick={() => handleDefaultDeploy()}>
                                                Deploy Alerts
                                            </DropdownItem>
                                        ) : (
                                            <DropdownItem disabled>Deploy Alerts</DropdownItem>
                                        )}
                                    </li>
                                    <li>
                                        {initiateRescan ? (
                                            <DropdownItem href="#" onClick={() => handleRefresh()}>
                                                Rescan Resources
                                            </DropdownItem>
                                        ) : (
                                            <div className='d-flex align-items-center'>
                                                <div>
                                                    <DropdownItem style={{ paddingInlineEnd: '5px' }}
                                                                  disabled>Rescan Resources</DropdownItem>
                                                </div>
                                                <div
                                                    onMouseOver={() => settright(true)}
                                                    onMouseLeave={() => settright(false)}
                                                >
                                                    <span
                                                    id="TooltipRight"
                                                    className="alert-icon">
                                                    <i className="mdi mdi-information-outline text-warning"/>
                                                    </span>
                                                    <Tooltip
                                                        placement="right"
                                                        isOpen={tright}
                                                        target="TooltipRight"
                                                        style={{
                                                            border: "2px solid #f1b44c",
                                                            borderRadius: "10px",
                                                            backgroundColor: "#2a3042",
                                                            // zIndex:100,
                                                        }}
                                                    >
                                                        If Rescan Resources button disabled, refresh page to check eligibility.
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        )}
                                    </li>
                                    {service_quota_item?service_quota_item():null}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                </Col>
                <Col md="2">
                    <Pagination aria-label="pagination navigation"
                                listClassName="justify-content-end pagination-rounded" className="mb-3">
                        <PaginationItem key={"pagination-item-" + Math.max(selectedPage - 1, 1)}
                                        disabled={selectedPage === 1}>
                            <PaginationLink
                                href="#"
                                onClick={() => handlePageClick(Math.max(selectedPage - 1, 1))}>
                                <i className="mdi mdi-chevron-left"/>
                            </PaginationLink>
                        </PaginationItem>
                        {[...Array(endPage - startPage + 1)].map((_, index) => (
                            <PaginationItem key={"pagination-item-" + index + (startPage + index)}
                                            active={selectedPage === startPage + index}>
                                <PaginationLink href="#" onClick={() => handlePageClick(startPage + index)}>
                                    {startPage + index}
                        </PaginationLink>
                    </PaginationItem>
                ))}
                <PaginationItem key={"pagination-item" + Math.min(selectedPage + 1, totalPages)}
                                disabled={selectedPage === totalPages}>
                    <PaginationLink
                        href="#"
                        onClick={() => handlePageClick(Math.min(selectedPage + 1, totalPages))}>
                        <i className="mdi mdi-chevron-right"/>
                    </PaginationLink>
                </PaginationItem>
            </Pagination>
                </Col>
            </Row>
            <Collapse isOpen={isOpen} id="filterCollapse">
                <Row>
                    <Row className="mb-3">
                        <Col md="1">
                            <label htmlFor="search-input" className="col-md-12 col-form-label">
                                Search:
                            </label>
                        </Col>
                        <Col md="2" lg={2}>
                            <Input
                                name="search"
                                className="input"
                                style={{border: '1px solid whitesmoke'}}
                                placeholder="Search: Name"
                                type="string"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        document.getElementById('search-button').focus();
                                    }
                                }}
                                value={name}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setName(e.target.value);
                                }}
                            />
                        </Col>
                        <Col md="1">
                            <label htmlFor="region-input" className="col-md-12 col-form-label">
                                Region:
                            </label>
                        </Col>
                        <Col md="2" lg={2}>
                            <Input
                                name="region"
                                className="input"
                                style={{border: '1px solid whitesmoke'}}
                                placeholder="Search: Region"
                                type="string"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        document.getElementById('search-button').focus();
                                    }
                                }}
                                value={regionInput}
                                onChange={(e) => {
                                    setRegion(e.target.value);
                                    setRegionInput(e.target.value);
                                }}
                            />
                        </Col>
                        {account_filter && (
                            <>
                                <Col md="1">
                                    <label htmlFor="region-input" className="col-md-12 col-form-label">
                                        Account:
                                    </label>
                                </Col>
                                <Col md="2" lg={2}>
                                    {account_filter()}
                                </Col>
                            </>
                        )}

                    </Row>
                    <Row className="mb-3">
                        <Col md="1">
                            <label htmlFor="search-input" className="col-md-12 col-form-label">
                                Filter By:
                            </label>
                        </Col>
                        <Col md={2} lg={2}>
                            <Multiselect
                            ref={resourceTypeRef}
                                name="resource_type"
                                placeholder="Type"
                                options={resourceFilter}
                                displayValue="name"
                                closeOnSelect={true}
                                onSelect={filterByResourceType}
                                onRemove={unfilterByResourceType}
                                style={{
                                    chips: {
                                        fontSize: '10px'
                                    },
                                   optionContainer:{backgroundColor: "#382b42"},
                                }}
                                selectedValues={initialResourceFilter}
                            />
                        </Col>
                        <Col md={2} lg={2}>
                            <Multiselect
                                ref={environmentRef}
                                name="env_name"
                                placeholder="Environment"
                                options={environmentsFilter}
                                displayValue="name"
                                closeOnSelect={true}
                                onSelect={filterByEnvironment}
                                onRemove={unfilterByEnvironment}
                                style={{
                                    chips: {
                                        fontSize: '10px'
                                    },
                                    optionContainer:{backgroundColor: "#382b42"}
                                }}
                                selectedValues={initialEnvironmentFilter}
                            />
                        </Col>
                        <Col md={2} lg={2}>
                            <Multiselect
                                ref={healthRef}
                                name="resource_type"
                                placeholder="Health"
                                options={healthFilter}
                                displayValue="name"
                                closeOnSelect={true}
                                onSelect={filterByHealth}
                                onRemove={unfilterByHealth}
                                style={{
                                    chips: {
                                        fontSize: '10px'
                                    },
                                    optionContainer:{backgroundColor: "#382b42"}
                                }}
                                selectedValues={initialHealthFilter}
                            />
                        </Col>
                        <Col md={2} lg={2}>{getFilter()}</Col>
                    </Row>
                    {/*<Row className="mb-3">*/}
                    {/*    <h6>Resources created in last:</h6>*/}
                    {/*    <Col md={1} lg={1}>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row className="mb-3 align-items-baseline">
                        <Col md={1} lg={1}>
                            <label htmlFor="search-input" className="col-md-12 col-form-label">
                                Created in:
                            </label>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last1Day"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    1 day
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last3Days"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    3 days
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last7Days"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    7 days
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last30Days"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    30 days
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="option1"
                                    onClick={toggleDates}
                                />
                                <label className="form-check-label">
                                    Custom
                                </label>
                            </div>
                        </Col>
                        <Col md={1}></Col>
                        <Col md={3} className='gap-3' style={{ display: 'flex', justifyContent: 'start'}}>
                            <div className="mb-3">
                                <button type="button" id="search-button" className="btn btn-primary w-md justify-content-end" onClick={() => handlePageClick(1)}>
                                    Search
                                </button>
                            </div>
                            <div className="mb-3">
                                <button type="button" id="search-button" className="btn btn-secondary" onClick={() => handleClearFilters(event)}>
                                    Clear Filters
                                </button>
                            </div>
                        </Col> 
                    </Row>
                    <Collapse isOpen={isDateOpen} id="filterDateCollapse">
                        <Row className="mb-3">
                            <Col md={2} lg={2}>
                                <label htmlFor="from-date-input" className="col-md-12 col-form-label">
                                    Created Date(from):
                                </label>
                            </Col>
                            <Col md={3} lg={3}>
                                <input
                                    className="form-control"
                                    type="date"
                                    placeholder='From'
                                    id="from-date-input"
                                    value={startDate ? startDate.toISOString().split('T')[0] : ''}
                                    onChange={handleStartDateChange}
                                />
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col md={2} lg={2}>
                                <label htmlFor="to-date-input" className="col-md-12 col-form-label">
                                    Created Date(to):
                                </label>
                            </Col>
                            <Col md={3} lg={3}>
                                <input
                                    className="form-control"
                                    type="date"
                                    placeholder='To'
                                    id="to-date-input"
                                    value={endDate ? endDate.toISOString().split('T')[0] : ''}
                                    onChange={handleEndDateChange}
                                />
                            </Col>
                        </Row>
                    </Collapse>
                    <Row className="mb-3">

                    </Row>
                </Row>
            </Collapse>
        </>
    );
};

export default ResourceActions;
